import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { isEmpty } from "../../helpers/Functions";

const BaseTooltip = ({ title, children, componentsProps = {}, placement = "top", ...rest }) => {
	const defaultTooltipSx = {
		fontWeight: "var(--font-weight-light)",
	};

	const mergedComponentsProps = {
		...componentsProps,
		tooltip: {
			sx: {
				...defaultTooltipSx,
				...(componentsProps.tooltip?.sx || {}),
			},
			...componentsProps.tooltip,
		},
	};

	return (
		<Tooltip title={isEmpty(title) ? "" : title} componentsProps={mergedComponentsProps} placement={placement || "top"} {...rest}>
			{children}
		</Tooltip>
	);
};

export default BaseTooltip;
